import { ScheduleMapper } from "@/domain/mappers";
import { ScheduleAvailableTimesResponse } from "../dtos/responses";
import { ScheduleAvailableTimes } from "@/domain/entities";
import moment from "moment";

export class ScheduleMapperImpl implements ScheduleMapper<ScheduleAvailableTimesResponse> {
  toScheduleAvailableTimesDomain(
    data: ScheduleAvailableTimesResponse,
  ): ScheduleAvailableTimes {
    const st = moment(data);
    let formatted_date = `${st.format(`dddd`)} das ${st.format(
      `HH[h]mm`,
    )} às ${st.add(50, "minutes").format(`HH[h]mm`)}`;
    formatted_date =
      formatted_date.charAt(0).toUpperCase() + formatted_date.slice(1);

    return {
      date: data,
      formatted_date: formatted_date,
    };
  }
}
